import { HELP_BASE_LANGUAGE, HELP_LANGUAGES, type HelpLanguage } from './types';

/** i18next code ("lt-LT", "lv-LV", "en-GB") → guide language; anything else → English. */
export const helpLanguageForLocale = (locale: string | null | undefined): HelpLanguage => {
  const code = (locale ?? '').slice(0, 2).toLowerCase();
  return HELP_LANGUAGES.find((lang) => lang === code) ?? HELP_BASE_LANGUAGE;
};
